<template>
  <div>
    <empty-card
      :table="true"
      :title="title"
    >
      <template slot="title">
        <b-button
          size="md"
          variant="dark"
          class="mx-md-1"
          @click="$router.push({name:'owner:insta-poster'})"
        >
          {{ $t('poster.add-post') }}
        </b-button>
      </template>
      <ok-table
        ref="datatable"
        :config="config"
      >
        <template
          slot="image-column"
          slot-scope="{props}"
        >
          <img
            :src="props.row.picture"
            width="50"
            height="50"
          >
        </template>
        <template
          slot="post-column"
          slot-scope="{props}"
        >
          <a
            v-b-tooltip.html.hover.bottom="props.row.caption?props.row.full_caption:''"
            :href="props.row.permalink"
            target="_blank"
          >
            {{ props.row.caption?props.row.caption:$t("no-text") }}
          </a>
        </template>
        <template
          slot="media_type-column"
          slot-scope="{props}"
        >
          {{ $t("instagram."+props.row.media_type) }}
        </template>
        <template
          slot="is_posted-column"
          slot-scope="{props}"
        >
          <b-badge :variant="props.row.is_posted?'success':'danger'">
            {{ $t(`general.${props.row.is_posted?'yes':'no'}`) }}
          </b-badge>

        </template>
        <template
          slot="engagement-column"
          slot-scope="{props}"
        >
          <div class="d-flex">
            <span class="mr-50">
              <i class="ml-10">{{ props.row.comments_count }}</i>
              <FeatherIcon
                size="20"
                fill="#0D8BF1"
                class="text-white"
                icon="MessageCircleIcon"
              />
            </span>
            <span>
              <i class="ml-10">{{ props.row.like_count }}</i>
              <FeatherIcon
                size="20"
                fill="#FB160A"
                class="text-white"
                icon="HeartIcon"
              />
            </span>

          </div>
        </template>
        <template
          slot="error-column"
          slot-scope="{props}"
        >
          <b-badge
            v-if="props.row.status===2"
            variant="danger"
          >
            {{ props.row.error }}
          </b-badge>
          <span v-else>-</span>
        </template>
        <template
          slot="actions-column"
          slot-scope="{props}"
        >

          <b-button
            v-if="!isSchedule"
            :variant="(props.row.reply || props.row.enabled)?'warning':'success'"
            size="sm"
            class="cursor-pointer"
            style="margin: 0 5px;min-width: 85px"
            @click="goReply(props.row)"
          >
            <span v-if="props.row.reply|| props.row.enabled">{{ $t('reply.edit') }}</span>
            <span v-else>{{ $t('reply.enable') }}</span>
          </b-button>
          <b-button
            v-if="!isSchedule"
            variant="primary"
            size="sm"
            class="cursor-pointer text-body mt-1 mt-md-0"
            style="margin: 0 5px"
            @click="showComment(props.row)"
          >
            <span> {{ $t('instagram.add-comment') }}</span>
          </b-button>
          <template v-else>
            <template v-if="!props.row.is_posted && props.row.status!==2">
              <b-button
                v-if="!props.row.is_posted"
                v-b-tooltip.html.hover.bottom="{title: $t('instagram.post-now')}"
                variant="primary"
                size="sm"
                class="cursor-pointer btn-icon text-body"
                style="margin: 0 5px"
                @click="postNow(props.row)"
              >
                <FeatherIcon icon="LogInIcon" />
              </b-button>
              <b-button
                v-b-tooltip.html.hover.bottom="{title: $t('forms.edit')}"
                variant="warning"
                size="sm"
                class="cursor-pointer btn-icon text-body"
                style="margin: 0 5px"
                @click="$router.push({name:'owner:insta-poster',params:{id:props.row.id}})"
              >
                <FeatherIcon icon="EditIcon" />
              </b-button>
            </template>
            <b-button
              v-b-tooltip.html.hover.bottom="{title: $t('form.delete')}"
              variant="danger"
              size="sm"
              class="cursor-pointer btn-icon text-body"
              style="margin: 0 5px"
              @click="handleDelete(props.row)"
            >
              <FeatherIcon icon="TrashIcon" />
            </b-button>
          </template>
        </template>
      </ok-table>
    </empty-card>
    <comment-modal
      v-model="showCommentModal"
      :post="selectedPost"
      @commented="increaseComments"
    />
  </div>
</template>

<script>
import { BButton, VBTooltip, BBadge } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import CommentModal from '@/views/owner-instagram/account/components/CommentModal'
import InstagramPosterApi from '@/api/instagram/poster'

export default {
  components: {
    CommentModal,
    EmptyCard,
    OkTable,
    BButton,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    isSchedule: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCommentModal: false,
      selectedPost: null,
      fetching: false,
    }
  },
  computed: {
    ...mapGetters({
      currentPage: 'instagram/currentAccount',
    }),
    title() {
      const tr = this.isSchedule ? 'schedule-posts-page-title' : 'posts-page-title'
      return this.$t(`reply.${tr}`, { page: this.currentPage.name })
    },
  },
  watch: {
    currentPage() {
      this.refreshTable()
    },
  },
  methods: {
    showComment(post) {
      this.showCommentModal = true
      this.selectedPost = post
    },
    increaseComments() {
      const index = this.$refs.datatable.$data.rows.findIndex(post => post.id === this.selectedPost.id)
      if (index > -1) {
        this.$refs.datatable.$data.rows[index].comments_count += 1
      }
    },
    refreshTable() {
      this.$refs.datatable.loadItems()
    },
    goReply(row) {
      this.$store.commit('reply/SET_DEFAULT_FORM')
      this.$router.push({ name: (row.reply || row.enabled ? 'owner:instagram-reply-edit' : 'owner:instagram-reply'), params: { id: row.id } })
    },
    handleDelete(row) {
      this.$okConfirm(this.$t('poster.delete-post-message'), {
        preConfirm: () => InstagramPosterApi.deletePost(this.currentPage.id, row.id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    postNow(row) {
      this.$okConfirm(this.$t('instagram.post-now-message'), {
        confirmButtonText: this.$t('instagram.post-now'),
        showCancel: true,
        preConfirm: () => InstagramPosterApi.postNow(this.currentPage.id, row.id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
  },
}
</script>
